
import React from 'react';

export default function LoadingScreen({ text = "Carregando..." }) {
    return (
        <div className="flex items-center justify-center h-screen bg-green-50">
            <div className="text-center">
                <div className="text-3xl font-bold text-green-700 animate-pulse">Escambo Digital</div>
                <p className="text-green-600 mt-2">{text}</p>
            </div>
        </div>
    );
}



